// ?invite=… из ссылки-приглашения. В Mini App приглашение приходит в start_param, его разбирает бэкенд.

export function getInvite(): string | null {
  const value = new URLSearchParams(window.location.search).get('invite')
  return value?.trim() || null
}

/** После входа убираем приглашение из адреса, чтобы оно не ушло повторно. */
export function dropInviteFromUrl(): void {
  const url = new URL(window.location.href)
  if (!url.searchParams.has('invite')) return
  url.searchParams.delete('invite')
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
}
